module.exports = __webpack_public_path__ + "static/media/nea-petnat.7b5cf911.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/nea-petnat.mp4
 ** module id = 463
 ** module chunks = 0
 **/